var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initialized)?_c('base-layout',{key:"initialized"},[_c('router-view')],1):_c('centred-spinner',{key:"spinner"})}
var staticRenderFns = []

export { render, staticRenderFns }